import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
//@ts-ignore
import ToolkitProvider, {
  Search, //@ts-ignore
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.js";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch } from "react-redux";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";
import { replaceAt } from "src/helpers/replaceAt";
import Breadcrumbs from "../Common/Breadcrumb";
import DeleteColumnButton from "./GridButtons/DeleteColumnButton";
import ColumnButton from "./GridButtons/ColumnButton";
import "./style.scss";
import ReactPaginate from "react-paginate";
import { ApiResponse } from "src/request/types";
import { CheckPermission } from "src/permissions/checkPermission";
import { useAppSelector } from "src/store";

export interface DataTableWithPaginationProps {
  key?: any;
  isDetails?: boolean;
  hideBreadcrumbs?: boolean;
  columns: any[];
  listData: any[];
  setDataList: (data: any[]) => void;
  action: any;
  paramQuery?: string;
  paramsid?: string;
  title?: string;
  addTitle?: string;
  onCreateClick?: () => void;
  gridButtons?: (keyValue: string, data: any) => any;
  editButton?: {
    condition?: (keyValue: string, data: any) => boolean;
    permission?: any;
    onClick: (keyValue: string, data: any) => void;
  };
  deleteButton?: {
    text: (keyValue: string, data: any) => string;
    action: any;
    permission?: any;
    condition?: (keyValue: string, data: any) => boolean;
    onClick: (keyValue: string, data: any) => void;
  };
  detailButton?: {
    condition?: (keyValue: string, data: any) => boolean;
    permission?: any;
    onClick: (keyValue: string, data: any) => void;
  };
}

const DataGrid = ({
  key = "Id",
  hideBreadcrumbs,
  gridButtons,
  deleteButton,
  detailButton,
  editButton,
  columns,
  listData,
  setDataList,
  title,
  action,
  paramQuery,
  paramsid,
  isDetails,
  addTitle,
  onCreateClick,
}: DataTableWithPaginationProps) => {
  const { t } = useTranslation();
  const { SearchBar } = Search;
  const btn = isDetails ? " " : "";
  const dispatch = useDispatch();
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const currentSearch = location.search;
  const [totalPage, setTotalPage] = useState(1);
  const searchParams = new URLSearchParams(location.search);
  const searchTake = searchParams.get("take");
  const searchPage = searchParams.get("page");
  const navigate = useNavigate();
  const { Id } = useParams<{ Id: string }>();
  const [page, setPage] = useState(
    searchPage !== null ? parseInt(searchPage) : 1
  ); //eslint-disable-next-line
  const [take, setTake] = useState(
    searchTake !== null ? parseInt(searchTake) : 10
  );
  useEffect(() => {
    setPage(1);
  }, [Id]);
  useEffect(() => {
    setLoader(true);
    if (!currentSearch) {
      navigate("?page=" + page + "&take=" + take);
    } else {
      if (currentSearch.includes("?page=")) {
        let query = replaceAt(currentSearch, 6, page);
        navigate(query);
      } else {
        navigate(
          "?page=" + page + "&take=" + take + currentSearch.replace("?", "&")
        );
      }
    }
    dispatch(
      action({
        payload: {
          onSuccess: (message: any, payload: any, res: ApiResponse<any>) => {
            setDataList(payload);
            setTotalPage(res.ResultDetail.TotalCount / res.ResultDetail.Take);
            setLoader(false);
          },
          onError: () => {
            setLoader(false);
          },
          onFinally: () => {
            setLoader(false);
          },
        },
        id: paramsid,
        params: paramQuery
          ? `?Skip=${(page - 1) * take}&Take=${take}&${paramQuery}`
          : `?Skip=${(page - 1) * take}&Take=${take}`,
      })
    ); // eslint-disable-next-line
  }, [page, Id]);

  const refresh = () => {
    setLoader(true);
    dispatch(
      action({
        payload: {
          //@ts-ignore
          onSuccess: (
            //@ts-ignore
            message,
            //@ts-ignore
            payload,
            //@ts-ignore
            details
          ) => {
            setDataList(payload);
            setTotalPage(details.TotalCount / details.Take);
            setLoader(false);
          },
          onError: () => {
            setLoader(false);
          },
        },
        id: paramsid,
        params: paramQuery
          ? `?Skip=${(page - 1) * take}&Take=${take}&${paramQuery}`
          : `?Skip=${(page - 1) * take}&Take=${take}`,
      })
    ); // eslint-disable-next-line
  };
  const user = useAppSelector((s) => s.auth.user);

  return (
    <React.Fragment>
      <ToolkitProvider
        keyField={key}
        data={listData}
        columns={columns.concat([
          {
            text: "",
            dataField: key,
            formatter: (cellContent: any, data: any) => (
              <div className="d-flex w-30 justify-content-end gap-1">
                {gridButtons && gridButtons(cellContent, data)}
                {detailButton &&
                  CheckPermission(user, detailButton.permission) &&
                  (detailButton.condition
                    ? detailButton.condition(cellContent, data)
                    : true) && (
                    <ColumnButton
                      buttonType="details"
                      onClick={() => {
                        return detailButton.onClick(cellContent, data);
                      }}
                    />
                  )}
                {editButton &&
                  CheckPermission(user, editButton.permission) &&
                  (editButton.condition
                    ? editButton.condition(cellContent, data)
                    : true) && (
                    <ColumnButton
                      buttonType="edit"
                      onClick={() => {
                        return editButton.onClick(cellContent, data);
                      }}
                    />
                  )}
                {deleteButton &&
                  (deleteButton.condition
                    ? deleteButton.condition(cellContent, data)
                    : true) &&
                  CheckPermission(user, deleteButton.permission) && (
                    <DeleteColumnButton
                      text={deleteButton.text(cellContent, data)}
                      onSuccessClick={() => {
                        return refresh();
                      }}
                      action={deleteButton.action}
                      id={cellContent}
                    />
                  )}
              </div>
            ),
          },
        ])}
        bootstrap4
        search
        columnToggle
        exportCSV
      >
        {(toolkitProps: any) => (
          <React.Fragment>
            <div className="m-grid-toolbar d-flex flex-wrap align-items-center justify-content-between gap-2">
              <div>
                {!hideBreadcrumbs && (
                  <Breadcrumbs
                    title={t("Breadcrumb.Dashboard")}
                    breadcrumbItem={title ?? ""}
                  />
                )}
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                <div className="search-box d-inline-block">
                  <div className="position-relative">
                    <SearchBar {...toolkitProps.searchProps} />
                    <i className="bx bx-search-alt search-icon-search" />
                  </div>
                </div>
                <button
                  type="button"
                  className={"btn btn-light btn-icon" + btn}
                  onClick={() => refresh()}
                >
                  <i className="mdi mdi-refresh"></i>
                </button>
                {onCreateClick && (
                  <button
                    onClick={() => {
                      return onCreateClick();
                    }}
                    className={"btn btn-primary" + btn}
                  >
                    <i className="bx bx-plus me-1"></i>
                    {addTitle ? addTitle : t("New")}
                  </button>
                )}
              </div>
            </div>

            <Card>
              <CardBody className="p-0">
                <div className="table-responsive" style={{ position: "relative" }}>
                  {loader && <Loader />}
                  <BootstrapTable
                    {...toolkitProps.baseProps}
                    classes={
                      "table align-middle table-nowrap table-hover table-header-colored mb-0"
                    }
                    bordered={false}
                    striped={false}
                  />
                </div>
                {totalPage > 1 && (
                  <div className="d-flex align-items-center justify-content-end px-3 py-3 border-top">
                    <ReactPaginate
                      className="customPagination"
                      breakLabel="..."
                      nextLabel=">"
                      onPageChange={(selected) => setPage(selected.selected + 1)}
                      pageRangeDisplayed={2}
                      pageCount={totalPage}
                      initialPage={page - 1}
                      previousLabel="<"
                      previousLinkClassName={"pagination__link"}
                      nextLinkClassName={"pagination__link"}
                      disabledClassName={"pagination__link--disabled"}
                      activeClassName={"pagination__link--active"}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </React.Fragment>
        )}
      </ToolkitProvider>
    </React.Fragment>
  );
};

export default DataGrid;
